// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"143":"178ab2f5","352":"75519d77","484":"75519d77","626":"75519d77","740":"75519d77","765":"75519d77","806":"75519d77"}[chunkId] + ".chunk.css";
};